

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { browserHistory } from 'react-router';
import styles from './Layout.css';
import withStyles from '../../decorators/withStyles';
import URLMgr from '../URLMgr';
import Header from '../Header';
import Modal from '../Modal';
import Menu from '../Menu';
import Footer from '../Footer';
import TranslatableVars from '../TranslatableVars';


class Layout extends Component {

  static propTypes = {
    children: PropTypes.element.isRequired,
    error: PropTypes.object,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.key !== this.props.location.key &&
          nextProps.location.state &&
          nextProps.location.state.modal) {

      this.previousChildren = this.props.children;
    }
  }

  render() {
    let isModal = this.props.location.state && this.props.location.state.modal && this.previousChildren;

    return (
      <div>
        <URLMgr />
        {isModal ?
          this.previousChildren :
          this.props.children
        }
        <Menu menuOpen={this.props.mobileMenuOpen} />
        {isModal && (
          <Modal isOpen={true} title={this.props.location.state.modalTitle} returnTo={this.props.location.state.returnTo} handleClick={() => {browserHistory.goBack()}}>
            {this.props.children}
          </Modal>
        )}
        <TranslatableVars />
        <Footer placeID={this.props.place ? this.props.place.id : ''} />
      </div>
    )
  }

}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(Layout);
